import { getLang, urlHelper } from "helpers/themeHelpers";
import { ICountryAsset } from "models/Assets/ICountryAsset";
import { ICityLiteAsset } from "models/Assets/ICityAsset";
import { useTheme } from "styled-components";

export const linkToOtherLanguage = () => {
  const locale = getLang();
  const otherLang = locale === "ar" ? "en" : "ar";
  const href = `/${otherLang}`;
  const onClick = () => {
    window.location.href = href;
  };
  return { onClick };
};

export const linkToHome = (city?: ICityLiteAsset) => {
  const locale = getLang();
  return `/${locale}${city && city.id ? "/" + urlHelper(city, locale) : ""}`;
};

export const linkToHomeWithOtherCountry = (country: ICountryAsset , hostNoSubDomain , locale) => {
  return `https://${country.abbreviation}.${hostNoSubDomain}/${locale}`;
};

export const linkToShoBidak = () => {
  return process.env.NEXT_PUBLIC_SHO_BIDAK_BASE_URL
}
export const linkToReadOpensooq = () => {
  return `https://read.opensooq.com`;
};

export const linkToAreaGuideOpensooq = () => {
  return "https://guide.opensooq.com/";
};

export const linkToChooseCountry = (country, locale) => {
  const { hostNoSubDomain, protocol } = useTheme();
  return `${protocol}://www.${hostNoSubDomain}/${locale}?ref=change_country_${country}`;
};

export const linkToSavedSearch = () => {
  const locale = getLang();
  return `/${locale}/recent-search/index`;
};

export const linkToBlogOpensooq = () => {
  const { country: countryAbbr } = useTheme();
  const blogCountries = ["jo", "iq", "eg", "om", "kw"];
  if (!blogCountries.includes(countryAbbr)) return null;
  return `https://${countryAbbr}.opensooq.com/blog/home/`;
};

export const linkToPalestineRadios = () => {
  return "/radios";
}
export const linkToCurrencyRates = () => {
  return "/CurrencyRates";
}
export const linkToCommercialDaleel = () => {
  return "/daleels";
}
export const linkToMedicleDaleel = () => {
  return "/medicals";
}

export const linkToCrafts = () => {
  return "/crafts";
}
export const linkToUniversities = () => {
  return "/universities";
}
export const linkToVaccinations = () => {
  return "/vaccinations";
}

export const linkToPalestinianUniversities = () => {
  return "/PalestineUniversities";

}
export const linkToPalestinianGrades = () => {
  return "/grades";
}

export const linkToHagzi = () => {
    return "https://hagzi.jo";
}
